import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * Outlet layout for /tools/imports/$id and any child routes
 * (currently /tools/imports/$id/results). The wizard content lives in
 * tools.imports.$id.index.tsx, the results page in
 * tools.imports.$id.results.tsx. See [[tanstack-route-layout-pattern]].
 */
export const Route = createFileRoute("/tools/imports/$id")({
  component: ImportDraftLayout,
});

function ImportDraftLayout() {
  return <Outlet />;
}
